/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FragmentNames {
  ASSIGN_PRIVACY_WARNING = 'assign-privacy-warning',
  ASSIGN_TERM_USE_MODAL = 'assign-term-use-modal',
  ASSING_TERM = 'assing-term',
  CALL_CATEGORIES = 'call-categories',
  CALL_DETAILS = 'call-details',
  CALLS = 'calls',
  CHANGE_PW = 'change-pw',
  CLINICAL_STAFF = 'clinical-staff',
  COOKIE_POLICIES = 'cookie-policies',
  FORM_TECHNICAL_VISIT = 'form-technical-visit',
  HOME = 'home',
  HPMS_REPORTS_MODAL = 'hpms-reports-modal',
  INACTIVITY = 'inactivity',
  LOCATOR_MEDICINE_MATERIALS = 'locator-medicine-materials',
  LOCATOR_MEDICINE_MATERIALS_PACKAGE = 'locator-medicine-materials-package',
  LOCATOR_PROCEDURE_PACKAGE = 'locator-procedure-package',
  LOCATOR_SERVICE = 'locator-service',
  LOCATOR_TABLE_PROCEDURE = 'locator-table-procedure',
  LOGIN = 'login',
  MENU_PROFILE = 'menu-profile',
  MY_DATA = 'my-data',
  NEGOTIATION = 'negotiation',
  NEGOTIATION_ATTACHMENTS = 'negotiation-attachments',
  NEGOTIATION_CONTRACT_ATTACHMENTS = 'negotiation-contract-attachments',
  NEGOTIATION_CONTRACTUAL_DRAFT = 'negotiation-contractual-draft',
  NEGOTIATION_DETAILS = 'negotiation-details',
  NEGOTIATION_DETAILS_TABCONTROL = 'negotiation-details-tabcontrol',
  NEGOTIATION_HISTORY = 'negotiation-history',
  NEGOTIATION_MATERIALS = 'negotiation-materials',
  NEGOTIATION_PACKAGES = 'negotiation-packages',
  NEGOTIATION_PROCEDURES = 'negotiation-procedures',
  NEGOTIATION_PROPOSAL = 'negotiation-proposal',
  NEGOTIATION_SERVICES = 'negotiation-services',
  NEGOTIATION_VALUE_SIDEBAR_MENU = 'negotiation-value-sidebar-menu',
  NEW_CALL = 'new-call',
  NEW_PW = 'new-pw',
  NEW_USER = 'new-user',
  NEW_USER_CONFIRMATION = 'new-user-confirmation',
  NOTIFICATIONS = 'notifications',
  PDF_VIEWER = 'pdf-viewer',
  PRIVACY = 'privacy',
  PRIVACY_WARNING = 'privacy-warning',
  PRIVACY_WARNING_CURRENT = 'privacy-warning-current',
  PROVIDER_ACCREDITATION = 'provider-accreditation',
  PROVIDER_ACCREDITATION_AMOUNT_PROFESSIONALS = 'provider-accreditation-amount-professionals',
  PROVIDER_ACCREDITATION_ATTACHMENT = 'provider-accreditation-attachment',
  PROVIDER_ACCREDITATION_BEDS = 'provider-accreditation-beds',
  PROVIDER_ACCREDITATION_BEDS_AND_EQUIPMENTS = 'provider-accreditation-beds-and-equipments',
  PROVIDER_ACCREDITATION_CLINICAL_STAFF = 'provider-accreditation-clinical-staff',
  PROVIDER_ACCREDITATION_CNES = 'provider-accreditation-cnes',
  PROVIDER_ACCREDITATION_CONCLUSION = 'provider-accreditation-conclusion',
  PROVIDER_ACCREDITATION_DOCUMENT_DETAIL = 'provider-accreditation-document-detail',
  PROVIDER_ACCREDITATION_DOCUMENTS = 'provider-accreditation-documents',
  PROVIDER_ACCREDITATION_EMPLOYEES = 'provider-accreditation-employees',
  PROVIDER_ACCREDITATION_EQUIPMENTS = 'provider-accreditation-equipments',
  PROVIDER_ACCREDITATION_ESTABLISHMENT = 'provider-accreditation-establishment',
  PROVIDER_ACCREDITATION_MEDICINE_MATERIALS = 'provider-accreditation-medicine-materials',
  PROVIDER_ACCREDITATION_OUTSOURCED_SERVICES = 'provider-accreditation-outsourced-services',
  PROVIDER_ACCREDITATION_PACKAGES = 'provider-accreditation-packages',
  PROVIDER_ACCREDITATION_PEOPLE_MANAGEMENT = 'provider-accreditation-people-management',
  PROVIDER_ACCREDITATION_PROCEDURES = 'provider-accreditation-procedures',
  PROVIDER_ACCREDITATION_PROFESSIONALS = 'provider-accreditation-professionals',
  PROVIDER_ACCREDITATION_QUALIFICATIONS = 'provider-accreditation-qualifications',
  PROVIDER_ACCREDITATION_QUESTIONNAIRE = 'provider-accreditation-questionnaire',
  PROVIDER_ACCREDITATION_SERVICE_MATERIALS = 'provider-accreditation-service-materials',
  PROVIDER_ACCREDITATION_SERVICES = 'provider-accreditation-services',
  PROVIDER_ACCREDITATION_SIDEBAR_MENU = 'provider-accreditation-sidebar-menu',
  PROVIDER_ACCREDITATION_SPECIALTY = 'provider-accreditation-specialty',
  PROVIDER_ACCREDITATION_VALIDATION = 'provider-accreditation-validation',
  REDIRECT = 'redirect',
  REGISTER_USER_SUCCESS = 'register-user-success',
  RESET_PW = 'reset-pw',
  ROOT = 'root',
  ROUTES = 'routes',
  SOCIAL_NETWORK = 'social-network',
  SUMMARY_NOTIFICATIONS = 'summary-notifications',
  TECHNICAL_VISIT = 'technical-visit',
  TECHNICAL_VISIT_APPOINTMENTS = 'technical-visit-appointments',
  TECHNICAL_VISIT_DETAIL = 'technical-visit-detail',
  TECHNICAL_VISIT_FORMS = 'technical-visit-forms',
  TECHNICAL_VISIT_INCONSISTENCIES = 'technical-visit-inconsistencies',
  TERM_OF_USE = 'term-of-use',
  TERM_PROVIDER_ACCREDITATION = 'term-provider-accreditation',
}
export { FragmentNames };
